import { Badge } from 'components';
import { formatDate } from 'utils/date';
import { BadgeColor, BadgePadding } from 'types';

interface DeactivatedBadgeProps {
  // List rows: the 28 px compact badge sits on the name's line, inside the
  // 56 px avatar height, so a deactivated row keeps its neighbours' height.
  compact?: boolean;
  // List rows (badge beside the name) and the phone profile header (~166 px
  // beside the Edit button) are too narrow for the date.
  hideDate?: boolean;
  deactivatedAt?: string | null;
}

// Shown wherever an employee or user appears while their access is revoked.
// Their records stay visible; the badge only marks that they cannot sign in.
export const DeactivatedBadge = ({
  compact,
  hideDate,
  deactivatedAt,
}: DeactivatedBadgeProps) =>
  deactivatedAt ? (
    <Badge
      noEllipsis
      styleType={BadgeColor.Red}
      style={{ flexShrink: 0, whiteSpace: 'nowrap' }}
      padding={compact ? BadgePadding.WideMedium : BadgePadding.Default}
      text={
        hideDate ? 'Deactivated' : `Deactivated ${formatDate(deactivatedAt)}`
      }
    />
  ) : null;
